export default __webpack_public_path__ + "static/media/approvecard.67d616ca.svg";